// extracted by mini-css-extract-plugin
export default {"root":"FmfYw","one":"l4xGH","multiple":"BhBna"};